























import Component from "vue-class-component";
import { Inject, Vue } from "vue-property-decorator";
import AccountService from "@/account/account.service";
import LoginService from "@/account/login.service";

@Component
export default class LoginPage extends Vue {
  @Inject('accountService')
  private accountService: () => AccountService;
  public user = '';
  public password = '';
  public rememberMe = false;

  mounted() {
    if (this.$store.getters.logon) {
      this.$router.push({ name: 'MenuPage' }).catch(() => {});
    }
  }

  public performLogin() {
    new LoginService().login();
  }
}
